import {Component, OnInit, ElementRef, AfterViewInit, Inject, Renderer2, OnDestroy} from '@angular/core';
import {RequestTypes} from "./request.types";
import {TimescaleTypes} from "./timescale.types";
import {ChartTypes} from "./chart.types";
import {ChartService} from "../service/chart.sevice";
import {Constants} from "../common/Constants";
import {Parser} from "../utils/parser";
import {WebSocketService} from "../service/web-socket.service";
import {Subscription} from "rxjs/Subscription";
import {Subject} from "rxjs/Subject";


@Component({
  selector: 'pro-chart',
  templateUrl:'./chart-component.html',
  styleUrls: ['./chart-component.css']
})
export class ChartComponent implements AfterViewInit, OnInit, OnDestroy {
  private objChartMain1 = null;
  subscription: Subscription;
  subject: Subject<string>;
  constructor(public chartService: ChartService, private dataService: WebSocketService){

  }

  ngOnInit() {
    /*this.dataService.getApiData().subscribe(data=>{
      console.log('component!'+ data);
    });*/

    /*this.chartService.testApiChart().then(data => {
      console.log(data);*/


    /*this.chartService.testApiAuth().then(data => {
      let token = data['results']['Auth-Token'];
      console.log('token' + token);
      this.chartService.testApiRequest(token).then(data => {
        console.log(data);
      })*/

   // })
    this.chartService.testApiAuth().then(data => {
      let token = data['results']['Auth-Token'];
      console.log('token' + token);
      this.chartService.testApiRequest(token).then(data => {
        console.log(data);
      })
    })
  // this.subject = this.dataService.getApiData();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.loadChartScripts(Constants.LOADER_FILEPATH, this.initProChartLoader.bind(this));
  }

  private initProChartLoader(){
    const prochartloader = ProChart_Loader();
    prochartloader.init.rootpath = Constants.LOADER_ROOTPATH;
    prochartloader.init.loadertemplates.push({ "layout": "layout2", "template": "default" });
    prochartloader.LoaderInitComplete  = this.eventLoaderComplete.bind(this);
    prochartloader.LoaderInitCombine();
  }

  private eventLoaderComplete(){
    this.objChartMain1 = ProChart_InitLayout("#layoutId3", "test", "default");
    //To use my_template remark the above line and unremark the following line:
    //objChartMain1 = ProChart_InitLayout("#layoutId1", "layout1", "my_template");

    this.objChartMain1.gui.init.timeframe = [

      { 'n': '1 Hour', 'id': '60M', 'f': 1 , 't1': '60M', 't2': ''},
      { 'n': '2 Hours', 'id': '2H', 'f': 1 , 't1': '2H', 't2': ''},
      { 'n': '4 Hours', 'id': '4H', 'f': 1 , 't1': '4H', 't2': ''}

    ];

    this.objChartMain1.gui.init.majors = [
      { 'name': 'BTC/USD', 'id': 'BTC/USD', 'description': 'BTC/USD' },
      { 'name': 'BTC/EUR', 'id': 'BTC/EUR', 'description': 'BTC/EUR' }];

    this.objChartMain1.guiinit.rootpath = Constants.GUI_ROOTPATH;

    //To use custome layout assign the full URL of the layoutfile into the following property
    //objChartMain1.apiinit.customLayoutFile = "../layout.mobile.js";
    //Unremark the following line to use differnt color theme for rendering engine (ChartCore)
    //objChartMain1.guiinit.customJsonCssFile = "../new.chart.css.json.js";

    this.objChartMain1.events.layout.readyComplete = this.eventlayoutReadyComplete_Instance1.bind(this);

    this.objChartMain1.guiinit.toolbaradv = true;

    //objChartMain1.guiinit.toolbox = false;
    //objChartMain1.guiinit.toolbar = false;
    this.objChartMain1.guiinit.menu = false;
    //objChartMain1.guiinit.zoom = false;
    // objChartMain1.guiinit.header = false;


    this.objChartMain1.gui.loadLayout(); //Init all innner object
    this.objChartMain1.events.layout.initComplete = this.eventlayoutInitComplete_Instance1.bind(this);
    this.objChartMain1.events.chart.createComplete = this.eventCreateChartComplete_Instance1.bind(this);
  }

  private loadChartScripts(url, callback): void {

   const script: any = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) {  //IE
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" ||
            script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {  //Others
      script.onload = function () {
        callback();
      };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  }

  private eventlayoutReadyComplete_Instance1() {
    //objChartMain1.api.layout.set('width||height', 900 + "||" + 400);
  }

  private eventlayoutInitComplete_Instance1() {
    this.objChartMain1.api.debug.level = 0;
    this.objChartMain1.apiinit.chart.ShowBarData = "false";
    this.objChartMain1.apiinit.chart.PriceChartType = ChartTypes.CANDLESTICKS;

    this.objChartMain1.chart.StudiesToLoad = []; //Make sure no default studies loaded
    this.objChartMain1.chart.Symbol = "BTC/USD"; //Set first asset to show
    this.objChartMain1.chart.SymbolName = "BTC/USD"; //Set first asset name
    this.objChartMain1.chart.TimeScale = TimescaleTypes.MIN5;      //Set first time-scale
    this.objChartMain1.chart.Precision = 4;      //Set first number of decimal digits

    this.objChartMain1.chart.Volume = { show:true , heightRelToPrice:20 };
    this.objChartMain1.chart.StudiesToLoad  = ["volume"];
    this.objChartMain1.chart.StudiesToLoad       = ["volume+"];
    //Set the data callback. Whenever "getrecenthistory" is called the chart changed symbol/asset or time-scale

    //Test call

    this.objChartMain1.chart.JSPush = { enableHistory: true, enableRT: true, enableSymbols: true, enableTemplates: true, funcFetchData: this.Chart_OnJPushRequest.bind(this) };
  };


  private eventCreateChartComplete_Instance1() {
     this.objChartMain1.gui.fullScreen();
    //This method will ask for the Majors symbols list for the menu
    //this.objChartMain1.apiactions.chart.GetSymbolsByGroup({ guiparent: null, guigroup: 'majors' }, 'majors');
    //Get search filter (optional)
     this.objChartMain1.apiactions.chart.GetCountries({ guiparent: null, guigroup: 'countries' });
     this.objChartMain1.apiactions.chart.GetMarkets({ guiparent: null, guigroup: 'markets' });
     this.objChartMain1.apiactions.chart.GetExchanges({ guiparent: null, guigroup: 'exchanges' });
  }

  private Chart_OnJPushRequest(objChartContext, objRequestContext, strRequest, objParamaters) {
  let objResponse;
  let data;

  switch (strRequest.toLowerCase()) {
    case RequestTypes.GET_RECENT_HISTORY:

      this.subject.subscribe(value => {
        let parsed = Parser.parseBinanceRecentHistoryData(value);
        this.objChartMain1.chart.Push(objChartContext, objRequestContext, RequestTypes.GET_RECENT_HISTORY, parsed);
      })
      /*this.chartService.exchangeDerivedRecords(false, 'BTC', 'USD', 'hour', '1', 'Bitfinex','1490044460', '1490145120', 'datetime').then(data => {
        let parsed = Parser.parseRecentHistoryData(data);
        this.objChartMain1.chart.Push(objChartContext, objRequestContext, RequestTypes.GET_RECENT_HISTORY, parsed);
      });*/

      break;
    case "gethistorybydates":
      //Here you fill historical candles for the compared symbol. Each call per a different asset
      //objChartMain1.chart.Push(objChartContext, objRequestContext, strRequest, data);
      break;
    case RequestTypes.GET_MULTIRT:
      //Here you fill the real-time data.
      //Once "getmultirt" is called at least once (after historical data filled) you can push RT data in any frequency, even outside the Chart's GetRT loop.
      //Remember to save the last objects objChartContext, objRequestContext and strRequest to use in the push calls.
      data=[{"id":"EUR/GBP","lastTimeStamp":"2016-07-08 20:59:04","data":[{"ask":0.8534,"bid":0.8531,"other":0,"date":"2016-07-08 20:59:04"}]}];
      this.objChartMain1.chart.Push(objChartContext, objRequestContext, strRequest, data);
      break;

    case "findsymbols":
      //This section used by the search symbol control
      //Remember to save the last objects objChartContext, objRequestContext and strRequest to use in the push calls.
      data = { "data":[ { "categoryId":"all", "categoryLabel":"All", "categoryDescription":"all symbols", "symbols":[ { "exchangeId":"forex", "marketId":"fx", "id":"EURUSD", "name":"EUR/USD", "description":"Euro US Dollar", "precision":4, "timescales":["1M","30M","1D"], "defaultTimescale":"30M" }, { "exchangeId":"forex", "marketId":"fx", "id":"AUDUSD", "name":"AUD/USD", "description":"Australian Dollar US Dollar", "precision":null, "timescales":null, "defaultTimescale":null }, { "exchangeId":"nasdaq", "marketId":"stocks", "countryId":"us", "id":"goog", "name":"Google", "description":"Google stock on nasdaq", "precision":2, "timescales":null, "defaultTimescale":null } ] }, { "categoryId":"stocks", "categoryLabel":"Stocks", "categoryDescription":"only stocks", "symbols":[ { "exchangeId":"nasdaq", "marketId":"stocks", "countryId":"us", "id":"goog", "name":"Google", "description":"Google stock on Nasdaq", "precision":2, "timescales":null, "defaultTimescale":null } ] }, ] };
      this.objChartMain1.chart.Push(objChartContext, objRequestContext, strRequest, data);
      break;

    case "getsymbolsbygroup":
      //This section used to fetch the list of assets for the Majors menu
      //Remember to save the last objects objChartContext, objRequestContext and strRequest to use in the push calls.
      data = { "data": [{ "exchangeId": "fx", "marketId": "forex", "countryId": null, "id": "EURUSD", "name": "EUR/USD", "description": "Euro vs US Dollar", "precision": 4, "timescales": ["1M", "30M", "1D"], "defaultTimescale": "30M"}] };
      this.objChartMain1.chart.Push(objChartContext, objRequestContext, strRequest, data);
      break;

    case "getexchanges":
      //This section used to fetch "excahnges" list for the filter inside "search symbol" popup.
      //Remember to save the last objects objChartContext, objRequestContext and strRequest to use in the push calls.
      data = { "data": [{ "id": "fx", "name": "FOREX", "description": "FOREX" }, { "id": "nasdaq", "name": "Nasdaq", "description": "Nasdaq Stock Exchange" }, { "id": "nyse", "name": "Nyse", "description": "New York Stock Exchange"}] };
      this.objChartMain1.chart.Push(objChartContext, objRequestContext, strRequest, data);
      break;

    case RequestTypes.GET_MARKETS:

      this.chartService.marketsRequest().then(data => {
        let parsed = Parser.parseData(data);
        this.objChartMain1.chart.Push(objChartContext, objRequestContext, 'getmarkets', parsed);
      });
      break;

    case "getcountries":

      //This section used to fetch "countries" list for the filter inside "search symbol" popup.
      //Remember to save the last objects objChartContext, objRequestContext and strRequest to use in the push calls.
      data = { "data": [{ "id": "fr", "name": "France", "description": "France", exchangeID: null }, { "id": "it", "name": "Italy", "description": "Italy", exchangeID: null}]};
      this.objChartMain1.chart.Push(objChartContext, objRequestContext, strRequest, data);
      break;
  }}

}






// WEBPACK FOOTER //
// ./src/app/chart/chart.component.ts